import { render, staticRenderFns } from "./AccommodatieClusterCard.vue?vue&type=template&id=52f28e2d&"
import script from "./AccommodatieClusterCard.vue?vue&type=script&lang=js&"
export * from "./AccommodatieClusterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports